import { createDefaults } from '../../utils/createDefaults';

type AuthMode = 'login' | 'register' | 'password';

// ======================
// FORM
// ======================
type Login = {
  email: string;
  password: string;
};

type Register = {
  email: string;
  password: string;
  confirm: string;
};

type Password = {
  email: string;
};

export const loginDefaults = createDefaults({
  email: '',
  password: '',
});

export const registerDefaults = createDefaults({
  email: '',
  password: '',
  confirm: '',
});

export const passwordDefaults = createDefaults({
  email: '',
});

// ======================
// REQUEST
// ======================
type LoginReq = {
  email: string;
  password: string;
};

type RegisterReq = {
  email: string;
  password: string;
  confirm: string;
};

type PasswordReq = {
  email: string;
};

type RefreshReq = {
  refreshToken: string;
};

type LogoutReq = {
  refreshToken: string;
  firebase_token?: string;
};

// ======================
// RESPONSE
// ======================
type LoginRes = {
  token: string;
  refreshToken: string;
};

type ApiRes = {
  success: boolean;
  error?: string;
  statusCode?: number;
};

type StatusRes = {
  status: number;
  message?: string;
};

type RefreshRes = {
  token: string;
  refreshToken: string;
};

export type {
  AuthMode,
  ApiRes,
  Login,
  Register,
  Password,
  LoginReq,
  RegisterReq,
  PasswordReq,
  RefreshReq,
  LogoutReq,
  LoginRes,
  RefreshRes,
  StatusRes,
};
